var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-form", { staticClass: "imperial-setting" }, [
    _c(
      "div",
      { staticStyle: { "text-align": "center", "padding-bottom": "5px" } },
      [
        _c("b", { staticStyle: { "font-size": "large" } }, [
          _vm._v(
            _vm._s(
              _vm.$t("CargoMsg.Cargo_ImperialUnits") +
                _vm.$t("CargoMsg.Cargo_Switch")
            )
          )
        ])
      ]
    ),
    _c(
      "div",
      [
        _c(
          "el-form-item",
          { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessType") } },
          [
            _c(
              "el-select",
              {
                attrs: { clearable: "" },
                model: {
                  value: _vm.currentKey,
                  callback: function($$v) {
                    _vm.currentKey = $$v
                  },
                  expression: "currentKey"
                }
              },
              _vm._l(_vm.imperialSetting, function(item) {
                return _c("el-option", {
                  key: item.key,
                  attrs: { value: item.key, label: _vm.languageFunc(item) }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._l(_vm.modules, function(item) {
          return _c(
            "div",
            { key: item.key },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": "100px",
                    label: _vm.languageFunc(item)
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.from[item.key],
                        callback: function($$v) {
                          _vm.$set(_vm.from, item.key, $$v)
                        },
                        expression: "from[item.key]"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-right": "15px" },
                          attrs: { label: false }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Metric")))]
                      ),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-right": "15px" },
                          attrs: { label: true }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Imperial")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        _c(
          "el-col",
          { staticClass: "color-save-btn" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
              [_vm._v(_vm._s(_vm.$t("Tool.Save")))]
            )
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }